<main>
  <div>
    <p>Liste des tags:</p>
    <div>
      <button (click)="removeTags(i)" *ngFor="let item of data.mediaOptions.tags; let i = index">{{item}}</button>
    </div>
  </div>
  <div>
    <p>Nouveau tags:</p>
    <input [(ngModel)]="inputValue"/>
    <button (click)="addTags(inputValue)">{{'add' | translation}}</button>
  </div>
  <div>
    <button (click)="close(null)"> {{'close' | translation}} </button>
  </div>
</main>
